import '../App.css';
import { useState, useContext } from 'react';
import { DynamicHeader, GetDimensions } from '../components/Header';
import Footer from '../components/Footer';
import { TitleCards } from '../TitleCards';
import { scrollToSection } from '../components/Header';

export default function GlobalHorizon() {

    const { profile, project, contact } = useContext(TitleCards);
    const [pageRendered, setPageRendered] = useState(true);

    const globeSVG = 
    <g>
        <path fillRule="evenodd" clipRule="evenodd" d="M18 6L18 4.5H19.5L20.25 5.25V11.25V15V18L19.5 18.75H13.7302L12 14.136L10.2698 18.75H4.5L3.75 18V15V11.25V5.25002L4.5 4.50002L6 4.50002V6.00002H5.25V11.25H18.75V6H18ZM18.75 12.75H13.0822L14.7697 17.25H18.75V15V12.75ZM5.25 12.75L5.25 15L5.25 17.25H9.23025L10.9178 12.75H5.25Z" fill="#e1e1e16c"/>
    </g>

    return (
        <div className='page-container good-views-page' style={{ backgroundSize: '100% 100%' }}>
            {pageRendered && scrollToSection('new_page')}
            {pageRendered && setPageRendered(false)}

            <DynamicHeader 
            visible={true}
            menu={GetDimensions().width < 600}
            profile={profile}
            project={project}
            contact={contact}
            />

            <div className='falling-leaves'>
                {[...Array(5)].map((_, i) => (
                    <svg key={i} className='falling-leaf-svg' xmlns="http://www.w3.org/2000/svg" width='24px' height='24px' viewBox="0 0 24 24">
                        {globeSVG}
                    </svg>
                ))}
            </div>

            <div className='caesar-column'>

                {GetDimensions().width < 600 && <div className='column'></div>}

                <div className='project-page'>

                    <div className='project-image-container good-views-title-container'>
                        <>GOOD</><>VIEWS</>
                    </div>

                    <div className='caesar-intro-container'>                   

                        <span className='good-views-subtitle'>Your Friendly Neighborhood Movie Webapp!</span><br/><br/>

                    </div>

                    <div className='project-page-desc-container'>
                        <h2 className='white-text'>THE PURPOSE OF GOOD VIEWS</h2>
                        <span className='good-views-subtitle'>WHY I BUILT IT?</span>
                        <div className='project-page-desc white-text'>
                            Good Views is a collaborative platform that helps you interact with movies in a unique way.
                            It allows you to review and rate movies and makes sharing with your friends and family fun and simple, 
                            making it easier than ever to discover new films and share your thoughts.
                            <br/><br/>
                            The platform is desinged for anyone looking to discover and share movies with friends.
                            You could be a casual viewer looking for something new or a cinephile aiming to explore
                            different genres, Good Views offers a convenient and effective way to discover and enjoy movies.
                        </div>

                        <h2 className='white-text'>BEHIND THE SCENES</h2>
                        <span className='good-views-subtitle'>MY APPROACH</span>
                        <div className='project-page-desc white-text'>
                            As I built this for family and friends - some of whom aren't the most tech savvy - 
                            I wanted to make sure that the user flow was as simple and intuitive as possible.
                            <br/><br/>
                            The steps are simple - you create an account, add your friends and then you can 
                            start sharing movies and reviews with each other.
                            <br/><br/>
                            I also wanted to make sure that the design was clean and visually appealing,
                            so I used dark blue and purple colours to simulate the feeling of being in a theatre
                            and to make the movie posters, reviews and highlighted elements pop.
                            
                        <h2 className='white-text'>THE PLATFORM STRUCTURE</h2>
                            <ul>
                                <li>
                                    <span className='good-views-subtitle' style={{ fontWeight: '700' }}>Platform Layout: </span>
                                    The platform is desinged to be simple. That is why there are only 3 main pages: The home page
                                    where users can see their own movies, reviews and friends reviews and recommendations, the search
                                    page where users can search for movies they have just seen and want to review or share, 
                                    and the profile page where users can edit their profile, add friends and edit their movie category lists.
                                </li>
                                <br/>
                                <li>
                                    <span className='good-views-subtitle' style={{ fontWeight: '700' }}>Movie API: </span>
                                    I used the TMDB API to get movie data such as posters, descriptions and ratings.
                                    This made it easy to populate the platform with a wide variety of movies and ensure that
                                    the information was accurate and up to date.
                                </li>
                            </ul>
                        </div>
                        <h2 className='white-text'>LIMITATIONS</h2>
                        <span className='good-views-subtitle'>WHAT TO WORK ON FOR THE FUTURE</span>
                        <div className='project-page-desc white-text'>
                             <ul>
                                <li>
                                    <span className='good-views-subtitle' style={{ fontWeight: '700' }}>API Costs: </span>
                                    The TMDB API is great, but it does have a cost associated with it once you go over a 
                                    certain number of requests. This is why I have not commercialised the app yet, 
                                    and is a big limitation for the future of the platform.
                                    <br/><br/>
                                    <span className='good-views-subtitle' style={{ fontWeight: '500' }}>Potential Fix: </span>
                                    To avoid the high API costs, I could look at sotring the data myself and caching what users
                                    have searched for on a redis cache to reduce the number of API calls and therefore reduce costs.
                                </li>
                                <br/>
                                <li>
                                    <span className='good-views-subtitle' style={{ fontWeight: '700' }}>App or Website?: </span>
                                    Initially, I wanted to launch GoodViews as a website. However, the more I built the more I realised,
                                    that we typically send movie recommendations to each other on our phones just after a movie ends.
                                    This made me realise that it would be more convenient to have the platform as an app rather than a
                                    website.
                                    <br/><br/>
                                    <span className='good-views-subtitle' style={{ fontWeight: '500' }}>Potential Fix: </span>
                                    Of course, the obvious solution to this is to build an app version of GoodViews. However, 
                                    putting apps on the App store does cost money - where a webapp is free for all phones.
                                    To reach a wider audience I will optimise the website version of the platform for mobile use while
                                    developing the app version.
                                </li>
                            </ul>
                        </div>
                        
                    </div>

                </div>
                {GetDimensions().width < 600 && <div className='column'></div>}
            </div>
            <Footer/>              
        </div>
    )
}